<!-- TAB C -->
<!-- Repairs Costs Widget-->
<div class="row pt-0">
    <div class="col-md-12">
        <div class="row pt-3 pb-4">
            <div class="col-md-3 col1" align="center">
                <h2>{{repairsYearly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Total year to date</h5>
                <p>___________________</p>
                <font *ngIf="repairsYearly == 0">NO RECORD FOR YEAR TO DATE</font>
                <font *ngIf="repairsYearly > 0">TOTAL REPAIR COST FOR YEAR TO DATE</font>
            </div>

            <div class="col-md-3 col2" align="center">
                <h2>{{repairsMonthly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Total this month</h5>
                <p>___________________</p>
                <font *ngIf="repairsMonthly == 0">NO RECORD FOR THE CURRENT MONTH</font>
                <font *ngIf="repairsMonthly > 0">TOTAL REPAIR COST FOR THE CURRENT MONTH</font>
            </div>

            <div class="col-md-3 col3" align="center">
                <h2>{{repairsWeekly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Total this week</h5>
                <p>___________________</p>
                <font *ngIf="repairsWeekly == 0">NO RECORD FOR THE CURRENT WEEK</font>
                <font *ngIf="repairsWeekly > 0">TOTAL REPAIR COST FOR THE CURRENT WEEK</font>
            </div>

            <div class="col-md-3 col4" align="center">
                <h2>{{repairsRecentCost | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                <h5>Latest Repair Cost</h5>
                <p>___________________</p>
                <font *ngIf="repairsRecentCost == 0">NO REPAIR COST ON RECORD</font>
                <font *ngIf="repairsRecentCost > 0"> COST FOR {{repairsRecentRego}} ON
                    {{ (repairsRecentDate !== null) ? (repairsRecentDate | date: 'dd MMM yyyy') : "UNRECORDED DATE"  }}</font>
            </div>
        </div>
    </div>
</div> <!-- End of Repairs Costs Widget-->
<br/>

<!-- Featured Buttons -->
<div class="row pt-0">
    <div class="col-md-12">
        <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false" ngbTooltip="Add New Repair Report" (click)="openRepairModal(null)">
            <span class="sr-only">Add</span>
            <i class="fa fa-lg fa-plus"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
        </button>
        
        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('repair-print-section')" placement="bottom" [disabled]="repairCount < 1" ngbTooltip="Print List">
            <i class="fa fa-lg fa-print"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
        </button>

        <div class="btn-group mr-1">
            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="repairCount < 1"
            placement="bottom" ngbTooltip="Export List">
                <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
            </button>
            <div class="dropdown-menu fs-12">
                <a (click)="repair_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                <a (click)="repair_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a>
                <a (click)="repair_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
            </div>
        </div>

        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
            <i class="fa fa-lg fa-filter"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
        </button>

        <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1" (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
            <i class="fa fa-lg fa-toggle-right"></i>
            <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
        </button>
       
        <div class="btn-group mb-1">
            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            placement="bottom" ngbTooltip="Show/Hide Columns">
                <span class="sr-only">Toggle Dropdown</span>
                <i class="fa fa-lg fa-check-square-o"></i>
                <span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
            </button>
            <div class="dropdown-menu fs-12" style="width: 150px;">
                <div class="col-md-12 mb-3 fs-12">
                    <input type="checkbox" [(ngModel)]="showDate"> Date<br />
                    <input type="checkbox" [(ngModel)]="showRego"> REGO<br />
                    <input type="checkbox" [(ngModel)]="showFleetType"> Fleet Type<br />
                    <input type="checkbox" [(ngModel)]="showDescription"> Description<br />
                    <input type="checkbox" [(ngModel)]="showProvider"> Provider<br />
                    <input type="checkbox" [(ngModel)]="showCost"> Cost<br />
                    <input type="checkbox" [(ngModel)]="showReceiptNo"> Receipt No<br />
                    <input type="checkbox" [(ngModel)]="showFile"> File<br />
                </div>
            </div>
        </div>

        <span *ngIf="myDropDown=='range'" class="pull-right" >&nbsp;
            <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
            ngxDaterangepickerMd
            [locale]="locale"
            startKey="start"
            endKey="end"
            [showWeekNumbers]="true"
            [showDropdowns]="true"
            [(ngModel)]="repairDateRange"
            (ngModelChange)="processRepairDateRange($event)"
            name="daterange"
            [autoApply]="true"
            opens="left"
            drops="down"
            [maxDate]="maxDate"
            />
        </span>

        <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
            <option value="today">Today</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="year">This Year</option>
            <option value="7">Last 7 days</option>
            <option value="14">Last 14 days</option>
            <option value="30">Last 30 days</option>
            <option value="90">Last 90 days</option>
            <option value="all">All Dates</option>
            <option value="range">Custom date range</option>
        </select>
    </div>
</div> <!-- End of Featured Buttons -->
<br>

<!-- Search Repairs List -->
<div class="row pt-0">
    <div class="col-md-12">
        <div widget class="card border-0 box-shadow" *ngIf="showFilters">
            <div class="card-header border-0 text-muted">
                <h5 class="mb-0">Search Repairs:</h5>
                <div class="widget-controls">
                    <a data-widgster="close" class="transition" (click)="toggleFilters()"><i
                        class="fa fa-times"></i></a>
                </div>
            </div>
            <div class="card-body card-header pt-0 widget-body">
                <div class="row">
                    <div class="form-group col">
                        <label>Provider:</label>
                        <select class="form-control form-control-sm" placeholder="Select"
                            [(ngModel)]="filterRepairProvider" (change)="updateFilter(prefixRepair)">
                            <option selected disabled>Select..</option>
                            <option *ngFor="let p of providers" value="{{p.id}}">{{p.company_name}}</option>
                        </select>
                    </div>
                    <div class="form-group col" *ngIf="parent!=prefix_fleet">
                        <label>REGO:</label>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="filterRepairRego"
                            (keyup)="updateFilter(prefixRepair)">
                    </div>
                </div>
                <div class="row" *ngIf="!isFilterEmpty">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                            <span class="badge badge-pill badge-white text-primary ml-1"><i
                                    class="fa fa-lg fa-filter"></i></span>
                            <span>Reset Filters</span>
                        </button> &nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> <!-- End of Search Repairs List -->

<br *ngIf="showFilters" />
<div class="row pt-3">
    <!-- REPAIRS TABLE -->
    <div [ngClass]="(showSidebar) ? 'col-md-8' : 'col-md-12'">
        <span>
            Items: <span style="color: rgb(23, 98, 141);">{{ (totalRepairs !== null) ?   (totalRepairs) : "0"}}</span>   |   
            Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageRepairAmount  && averageRepairAmount !== null) ?   '$' + (averageRepairAmount | number:'1.2-2') : "0.00"}}</span> |
            Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalRepairAmount  && totalRepairAmount !== null) ?   '$' + (totalRepairAmount | number:'1.2-2') : "0.00"}}</span>
        </span>
        <div class="">
            <ngx-loading [show]="loading_indicator4"></ngx-loading>
            <ngx-datatable *ngIf="repair_rows && !loading_indicator4"
                [loadingIndicator]="loading_indicator4"
                class="material"
                [rows]="repair_rows"
                [columnMode]="'force'"
                [footerHeight]="40"
                [rowHeight]="'auto'"
                [limit]="10"
                [selected]="selected"
                [selectionType]="'single'"
                [scrollbarH]="true">

                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="90">
                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                        <div align="left" style="padding-right:20px">
                            <a container="body" placement="top" ngbTooltip="Edit" (click)="openRepairModal(row)"><i
                                class="fa fa-lg fa-pencil"></i></a>&nbsp;
                            <a container="body" placement="top" ngbTooltip="Delete"
                                (click)="openDeleteObjModal(row, prefixRepair, modalDeleteObj)"><i
                                    class="fa fa-lg fa-trash"></i></a>
                        </div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="date_done" name="Date" [width]="100" *ngIf="showDate">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        {{ (formatDate(value) !== null) ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                    </ng-template>
                </ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showRego" prop="rego" name="REGO" [width]="110"></ngx-datatable-column>

                    <ngx-datatable-column *ngIf="showFleetType" headerClass="header" [width]="120">
                        <ng-template let-column="column" ngx-datatable-header-template >
                            Fleet Type
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.fleet_type}} <span *ngIf="row.subtype !=='' && row.subtype != null">- {{row.subtype}}</span>
                        </ng-template>
                    </ngx-datatable-column>                   

                <ngx-datatable-column prop="repair_description" name="Description" *ngIf="showDescription"></ngx-datatable-column>

                <ngx-datatable-column name="Provider" prop="provider" headerClass="header" [width]="120"  *ngIf="showProvider"></ngx-datatable-column>

                <ngx-datatable-column prop="cost" name="Cost" headerClass="header-currency" [width]="100" *ngIf="showCost">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <div align="right" style="padding-right:20px"> ${{ value | number:'3.2-5'}}</div>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column prop="receipt_no" name="Receipt No" *ngIf="showReceiptNo"></ngx-datatable-column>

                <ngx-datatable-column prop="file" name="File" [width]="204" *ngIf="showFile">
                    <ng-template let-value="value" ngx-datatable-cell-template>
                        <a href="{{folderPath}}{{value}}" target="_new">{{value}}</a>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>
        </div>
    </div> <!-- END OF REPAIRS TABLE -->

    <!-- DETAILS SIDEBAR -->
    <div class="col-md-4" *ngIf="showSidebar">
        <div widget class="card border-0 box-shadow selected-column">
            <div class="card-header transparent border-0 text-muted"></div>
            <div class="card-body pt-0 widget-body">
                <ul>
                    <div *ngIf="selected">
                        <div *ngFor='let sel of selected'>
                            <div class="col-md-12">
                                <h6 class="titleHeader" style="padding-left: 0px;">{{sel["rego"]}} Details:</h6>
                                <a *ngIf="sel['file']!==null && sel['file']!==''" href="{{folderPath}}{{sel['file']}}" target="_new" title="View File">
                                    <i class="fa fa-file"></i>
                                </a><br/>

                                <tr>
                                    <td><b>Date:</b></td>
                                    <td class="col-md-7">{{ (formatDate(sel["date_done"]) !== null) ? (formatDate(sel["date_done"]) | date: 'dd MMM yyyy') : "No Date"  }}-{{sel.time_done}}</td>
                                </tr>

                                <tr>
                                    <td><b>Description:</b></td>
                                    <td class="col-md-7">{{sel.repair_description}}</td>
                                </tr>

                                <tr>
                                    <td><b>Fleet Type:</b></td>
                                    <td class="col-md-7">{{sel.fleet_type}}
                                        <span *ngIf="sel.subtype !=='' && sel.subtype != null">- {{sel.subtype}}</span>
                                    </td>
                                </tr>

                                <tr>
                                   <td><b>Provider:</b></td>
                                   <td class="col-md-7">{{sel.provider}}</td>
                                </tr>

                                <tr>
                                    <td><b>Cost:</b></td>
                                    <td class="col-md-7">${{sel.cost | number:'3.2-5'}}</td>
                                </tr>

                                <tr>
                                    <td><b>Driver:</b></td>
                                    <td class="col-md-7">
                                        <span *ngFor="let d of drivers">
                                            <span *ngIf="d.id == sel.driver_id">{{d.full_name}}</span>
                                        </span>
                                    </td>
                                </tr>

                                <tr>
                                    <td><b>Receipt No:</b></td>
                                    <td class="col-md-7">{{sel.receipt_no}}</td>
                                </tr>

                                <tr>
                                    <td><b>Fault:</b></td>
                                    <td class="col-md-7">{{sel.fault}}</td>
                                </tr>

                                <tr>
                                    <td><b>Hours:</b></td>
                                    <td class="col-md-7">{{sel.hours}}</td>
                                </tr>

                                <tr>
                                    <td><b>Odometer:</b></td>
                                    <td class="col-md-7">{{sel.mileage}}</td>
                                </tr>

                                <tr>
                                    <td><b>Note:</b></td>
                                    <td class="col-md-7">{{sel.note}}</td>
                                </tr>
                            </div><br />
                            <div class="col-md-12"><br />
                                <button type="button" class="btn btn-secondary mb-1 btn-sm" (click)="openRepairModal(sel);">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                        class="fa fa-lg fa-pencil"></i></span>
                                    Edit
                                </button>&nbsp;
                                <button type="button" class="btn btn-danger mb-1 btn-sm"
                                    (click)="openDeleteObjModal(sel, prefixRepair, modalDeleteObj)">
                                    <span class="badge badge-pill badge-white text-primary ml-1"><i
                                        class="fa fa-lg fa-trash"></i></span>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!selected.length" class="text-center">
                        <p> Select an item to display details. </p>
                    </div>
                </ul>
                <br />
            </div>
        </div>
    </div><!-- END DETAILS SIDEBAR -->
</div>
<div class="row">
    <div class="col-md-12">
        <small><i>Click on a row to select. Details on a selected row are shown on the right window.</i></small>
    </div>
</div>
<!-- END TAB C -->

<!-- START OF ADD REPAIR FORM -->
<ng-template #modalRepair let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode==false">Add New Repair</h5>
            <h5 class="modal-title" *ngIf="isEditMode==true">Edit Repair Record</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="repairForm" novalidate (ngSubmit)="onSubmitRepair(repairForm.value)">
        <div class="modal-body bg-gray">
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span> :</h6>
                    <input formControlName="date_done" class="form-control form-control-sm" type="date" required> 
                    <div *ngIf="repairForm.controls.date_done.touched">
                        <div *ngIf="repairForm.controls.date_done.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4"> 
                    <h6>Time :</h6>
                    <ngb-timepicker formControlName="time_string" [meridian]="true" class="changeSize"></ngb-timepicker>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Cost<span class="text-danger">*</span> :</h6>
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                    <input formControlName="cost" class="form-control form-control-sm" type="text" required>
                    </div>
                    <div *ngIf="repairForm.controls.cost.touched">
                        <div *ngIf="repairForm.controls.cost.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="repairForm.controls.cost.errors?.pattern && !isCost()">
                            <small class="text-danger" >Cost must have a valid currency value.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <h6>Provider<span class="text-danger">*</span> :</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="provider_id" required>
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let p of providers" value="{{p.id}}">{{p.company_name}}</option>
                    </select>
                    <div *ngIf="repairForm.controls.provider_id.touched">
                        <div *ngIf="repairForm.controls.provider_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <h6>Driver<span class="text-danger">*</span> :</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id" required> 
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                    </select>
                    <div *ngIf="repairForm.controls.driver_id.touched">
                        <div *ngIf="repairForm.controls.driver_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4">
                    <h6>Fleet<span class="text-danger">*</span> :</h6>
                    <select [id]="fleet_id" class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.fleet_id_num}} ({{fl.rego}})</option>
                    </select>
                    <div *ngIf="repairForm.controls.fleet_id.touched">
                        <div *ngIf="repairForm.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Description<span class="text-danger">*</span> :</h6>
                    <input formControlName="repair_description" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="repairForm.controls.repair_description.touched">
                        <div *ngIf="repairForm.controls.repair_description.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Receipt No<span class="text-danger">*</span> :</h6>
                    <input formControlName="receipt_no" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="repairForm.controls.receipt_no.touched">
                        <div *ngIf="repairForm.controls.receipt_no.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="repairForm.controls.receipt_no.errors?.pattern">
                            <small class="text-danger" >This field requires numeric values only.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Fault<span class="text-danger">*</span> :</h6>
                    <input formControlName="fault" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="repairForm.controls.fault.touched">
                        <div *ngIf="repairForm.controls.fault.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Note:</h6>
                    <input formControlName="note" class="form-control form-control-sm" type="text">
                </div>
                <div class="form-group col-md-4" >
                    <h6>Hours :</h6>
                    <input formControlName="hours" class="form-control form-control-sm" type="text"> 
                </div>
                <div class="form-group col-md-4" >
                    <h6>Odometer: <span class="text-danger">*</span></h6>
                    <input formControlName="mileage" class="form-control form-control-sm" type="text">
                    <div *ngIf="repairForm.controls.mileage.touched">
                        <div *ngIf="repairForm.controls.mileage.errors?.pattern && !isMileage()">
                            <small class="text-danger" >This field requires numeric values only.</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group" *ngIf ="(fileExists==true)">
                        <h6>File:</h6><br/>
                        <label>{{repair?.file}}</label> <button class="btn btn-primary btn-sm" type="button" (click)="removeFile(prefixRepair)">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <h6>File :</h6>
                        <app-image-uploader (passImage)="getFile($event, prefixRepair)"></app-image-uploader>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!repairForm.valid || spinner == true" >Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!repairForm.valid || spinner == true" >Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus>Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL ADD REPAIR FORM -->

<!-- START OF DELETE OBJECT FORM -->
<ng-template #modalDeleteObj let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete {{title}}</h5>
        <button type="button" class="close" (click)="modalClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
            Do you really want to delete this {{title}}?
            <h5>{{objToDelete.rego}}</h5>
            <p style="word-break: break-all">{{fileToDelete}}</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteObj(objToDelete)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="modalClose()" ngbAutofocus>Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE OBJECT FORM -->

<!-- START REPAIR PRINT-->
<div id="repair-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showDate">DATE</th>
            <th align="left" *ngIf="showRego">REGO</th>
            <th align="left" *ngIf="showFleetType">FLEET TYPE</th>
            <th align="left" *ngIf="showDescription">DESCRIPTION</th>
            <th align="left" *ngIf="showProvider">PROVIDER</th>
            <th align="left" *ngIf="showCost">COST</th>
            <th align="left" *ngIf="showReceiptNo">RECEIPT NO</th>
            <th align="left" *ngIf="showFile">FILE</th>
        </tr>
        <tr *ngFor="let row of repair_rows">
            <td *ngIf="showDate">{{ (formatDate(row.date_done) !== null && row.date_done != '0000-00-00') ? (formatDate(row.date_done) | date: 'dd MMM yyyy') : "No Date"  }}  </td> 
            <td *ngIf="showRego">{{row.rego}}</td>
            <td *ngIf="showFleetType">{{row.fleet_type}} - {{row.subtype}}</td>
            <td *ngIf="showDescription">{{row.repair_description}}</td>
            <td *ngIf="showProvider">{{row.provider}}</td>
            <td *ngIf="showCost">${{row.cost  | number:'3.2-5'}}</td>
            <td *ngIf="showProvider">{{row.receipt_no}}</td>
            <td><div class="justify-content-left" *ngIf="showFile"><a href="{{folderPath}}/{{row.file}}" target="_new">{{row.file}}</a></div></td>
        </tr>
    </table>
</div>
<!-- END PRINT -->